import IconBullet from "@/app/(site)/_components/Atoms/Icons/IconBullet"
import Text from "@/app/(site)/_components/Atoms/Text"

export type BulletListProps = {
    title: string[]
}

export default function BulletList({ title }: BulletListProps) {
    return (
        <ol className="flex list-none flex-col gap-y-0 md:gap-y-2">
            {title &&
                title.map((item, index) => (
                    <li key={index} className="flex items-start justify-start gap-8">
                        <span className="md:text-16">
                            <IconBullet className="h-20 w-20" />
                        </span>
                        <Text
                            weight="regular"
                            size="large"
                            className="!text-14 md:!text-[16px]"
                        >
                            {item}
                        </Text>
                    </li>
                ))}
        </ol>
    )
}
